import { z } from 'zod';
import { mutation } from '../../utils';
export const openLootbox = mutation({
    method: 'POST',
    path: '/open-lootbox',
    body: z.object({
        type: z.enum(['common', 'epic', 'rare']),
    }),
    responses: {
        200: z.object({
            prizeInCents: z.number(),
        }),
    },
});
